/**
 * Tour Types
 * TypeScript types for driver.js tour system
 */


export interface TourStep {
  element: string
  popover: {
    title: string
    description: string
    side?: 'top' | 'bottom' | 'left' | 'right'
    align?: 'start' | 'center' | 'end'
  }
}

export interface TourConfig {
  name: string
  steps: TourStep[]
  showProgress?: boolean
  allowClose?: boolean
  onComplete?: () => void
  onDestroyed?: (element?: Element) => void
}

export interface Tour {
  startTour: () => void
  isCompleted: boolean
  reset: () => void
}

export interface TourManager {
  startTour: (tourName: TourName) => void
  resetTour: (tourName: TourName) => void
  resetAllTours: () => void
  isTourCompleted: (tourName: TourName) => boolean
  shouldShowTour: (tourName: TourName) => boolean
  getTourCompletionDate: (tourName: TourName) => string | null
}

export type TourName =
  | 'home'
  | 'professionals-list'
  | 'professional-detail'
  | 'profile'
  | 'professions'
  | 'professional-profile-form'

export const TOUR_STORAGE_PREFIX = 'tour-completed-'
export const TOUR_DATE_PREFIX = 'tour-completed-date-'
